import React, { Fragment } from 'react'

interface ProgressProps {
  progress: number
}

export default ({ progress }: ProgressProps) => {
  const progressParams = {
    25: {
      width: '30',
      height: '30',
      cxLayerOne: '15',
      cyLayerOne: '15',
      rLayerOne: '15',
      fillLayerOne: '#E5E5E9',
      dLayerTwo: `M15 0C16.9698 2.349e-08 18.9204 0.387987 20.7403 1.14181C22.5601 1.89563 24.2137 3.00052 25.6066 
      4.3934C26.9995 5.78628 28.1044 7.43987 28.8582 9.25975C29.612 11.0796 30 13.0302 30 15L15 15L15 0Z`,
      fillLayerTwo: '#572FAE'
    },
    33: {
      width: '30',
      height: '30',
      cxLayerOne: '15',
      cyLayerOne: '15',
      rLayerOne: '15',
      fillLayerOne: '#E5E5E9',
      dLayerTwo: `M15 0C17.6328 3.13956e-08 20.2192 0.692954 22.4993 2.00923C24.7794 3.3255 26.673 5.21872 27.9896 7.49864C29.3062 
      9.77856 29.9996 12.3649 30 14.9976C30.0004 17.6304 29.3079 20.2169 27.992 22.4973L15 15L15 0Z`,
      fillLayerTwo: '#572FAE',
    },
    50: {
      width: '30',
      height: '30',
      cxLayerOne: '15',
      cyLayerOne: '15',
      rLayerOne: '15',
      fillLayerOne: '#E5E5E9',
      dLayerTwo: `M15.5 0C17.4698 2.349e-08 19.4204 0.387987 21.2403 1.14181C23.0601 1.89563 24.7137 3.00052 26.1066 4.3934C27.4995 
      5.78628 28.6044 7.43987 29.3582 9.25975C30.112 11.0796 30.5 13.0302 30.5 15C30.5 16.9698 30.112 18.9204 29.3582 20.7403C28.6044 
      22.5601 27.4995 24.2137 26.1066 25.6066C24.7137 26.9995 23.0601 28.1044 21.2402 28.8582C19.4204 29.612 
      17.4698 30 15.5 30L15.5 15L15.5 0Z`,
      fillLayerTwo: '#572FAE'
    },
    66: {
      width: '30',
      height: '30',
      cxLayerOne: '15',
      cyLayerOne: '15',
      rLayerOne: '15',
      fillLayerOne: '#E5E5E9',
      dLayerTwo: `M15.3335 0C17.9667 3.14004e-08 20.5535 0.693164 22.8338 2.00981C25.1142 3.32647 27.0078 5.22021 28.3243 
      7.50068C29.6407 9.78115 30.3337 12.368 30.3335 15.0012C30.3333 17.6344 29.6399 20.2211 28.3231 22.5014C27.0063 24.7816 25.1124 
      26.6751 22.8318 27.9914C20.5512 29.3077 17.9643 30.0004 15.3311 30C12.698 29.9996 10.1113 29.306 7.83112 27.989C5.55096 26.672 
      3.65766 24.778 2.34155 22.4973L15.3335 15L15.3335 0Z`,
      fillLayerTwo: '#572FAE'
    },
    75: {
      width: '30',
      height: '30',
      cxLayerOne: '15',
      cyLayerOne: '15',
      rLayerOne: '15',
      fillLayerOne: '#E5E5E9',
      dLayerTwo: `M15 0C17.9667 3.53778e-08 20.8668 0.879735 23.3336 2.52796C25.8003 4.17618 27.7229 6.51886 28.8582 9.25975C29.9935 
      12.0006 30.2906 15.0166 29.7118 17.9264C29.133 20.8361 27.7044 23.5088 25.6066 25.6066C23.5088 27.7044 20.8361 29.133 17.9264 
      29.7118C15.0166 30.2906 12.0006 29.9935 9.25975 28.8582C6.51886 27.7229 4.17618 25.8003 2.52796 23.3336C0.879734 
      20.8668 -7.07556e-08 17.9667 0 15L15 15L15 0Z`,
      fillLayerTwo: '#572FAE'
    },
    100: {
      width: '31',
      height: '30',
      cxLayerOne: '15.5',
      cyLayerOne: '15',
      rLayerOne: '15',
      fillLayerOne: '#E5E5E9',
      cxLayerTwo: '15.5',
      cyLayerTwo: '15',
      rLayerTwo: '15',
      fillLayerTwo: '#572FAE',
    }
  }

  return (
    <Fragment>
      <svg
        width={progressParams[progress].width}
        height={progressParams[progress].height}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {progress === 100
          ? <Fragment>
            <circle cx={progressParams[progress].cxLayerOne} cy={progressParams[progress].cyLayerOne}
              r={progressParams[progress].rLayerOne} fill={progressParams[progress].fillLayerOne} />
            <circle cx={progressParams[progress].cxLayerTwo} cy={progressParams[progress].cyLayerTwo}
              r={progressParams[progress].rLayerTwo} fill={progressParams[progress].fillLayerTwo} />
          </Fragment>
          : <Fragment>
            <circle cx={progressParams[progress].cxLayerOne} cy={progressParams[progress].cyLayerOne}
              r={progressParams[progress].rLayerOne} fill={progressParams[progress].fillLayerOne} />
            <path d={progressParams[progress].dLayerTwo} fill={progressParams[progress].fillLayerTwo} />
          </Fragment>
        }
      </svg>
    </Fragment>
  )
}
